import {
  STORE_REQUEST,
  STORE_MAIN_GET,
  STORE_SUCCESS,
  STORE_FAILURE,
  STORE_CATEGORIES_GET_LIST,
  STORE_CATEGORIES_GET_ALL,
  STORE_CATEGORIES_GET,
  STORE_CATEGORIES_REQUEST,
  STORE_CATEGORIES_SUCCESS,
  STORE_CATEGORIES_FAILURE,
  STORE_BOOK_REQUEST,
  STORE_BOOK_GET_LIST,
  STORE_BOOK_GET,
  STORE_BOOK_REVIEW_GET_LIST,
  STORE_BOOK_REVIEW_REQUEST,
  STORE_BOOK_REVIEW_SUCCESS,
  STORE_BOOK_REVIEW_FAILURE,
  STORE_BOOK_SUCCESS,
  STORE_BOOK_FAILURE,
  STORE_CATEGORY_BOOKS_GET_LIST,
  STORE_CATEGORY_BOOKS_REQUEST,
  STORE_CATEGORY_BOOKS_SUCCESS,
  STORE_CATEGORY_BOOKS_FAILURE,
  STORE_ENOTE_GET_LIST,
  STORE_ENOTE_REQUEST,
  STORE_ENOTE_SUCCESS,
  STORE_ENOTE_FAILURE,
  STORE_SEARCH_MAIN,
  STORE_SEARCH_TERM,
  STORE_SEARCH_REQUEST,
  STORE_SEARCH_SUCCESS,
  STORE_SEARCH_FAILURE,
  STORE_ANNOUNCEMENT_GET_LIST,
  STORE_ANNOUNCEMENT_REQUEST,
  STORE_ANNOUNCEMENT_SUCCESS,
  STORE_ANNOUNCEMENT_FAILURE,
  STORE_LOADING_STOP,
  // 이부분부터 타입추가
  DELIVERY_LIST_GET,
  DELIVERY_LIST_SUCCESS,
  DELIVERY_LIST_FAILED,
  // 팝업 추가
  STORE_POPUP,
  STORE_POPUP_SUCCESS,
  STORE_POPUP_FAILURE,
  STORE_EVENT_CATEGORIES_GET,
  STORE_EVENT_CATEGORIES_REQUEST,
  STORE_EVENT_CATEGORIES_SUCCESS,
  STORE_EVENT_CATEGORIES_FAILURE
} from '@/store/types'

import axios from '@/store/axios'

/* 
  This maps object keys from backend to frontend
  [backend]: frontend

*/
const keyMapper = {
  relatedBooks: 'related',
  recommBooks: 'recommended',
  newBooks: 'new',
  popularBooks: 'popular',
  enoteRankList: 'enotes',
  bookNm: 'title',
  bookSubName: 'subTitle',
  bookCd: 'id',
  enoteCd: 'id',
  enoteNm: 'title',
  thumbUrl: 'img',
  noteYn: 'hasNote',
  idx: 'id',
  catgryNm: 'title',
  catgryCd: 'id',
  rate: 'rating',
  publishDate: 'date',
  catgryPathList: 'categories',
  catgryPath: 'label',
  bookDesc: 'description',
  bookToc: 'contents',
  bookSize: 'bookSize',
  ebookOnlyYn: 'ebookOnly'
}
// const DeliveryListKeyMapper = {
//   emsCountryCd: 'emsAreaCd',
//   emsCountryNm: 'emsAreaNm'
// }

const mapNewKey = (obj, keysMap) => {
  Object.keys(keysMap).map((newKey) => {
    const re = new RegExp(`"${newKey}":`, 'g')
    obj = JSON.parse(JSON.stringify(obj).replace(re, `"${keysMap[newKey]}":`))
  })
  return obj
}

/*
import _ from 'lodash'
const mapNewKey = (obj, keysMap) => {
  return _.transform(obj, (result, value, key) => {
    const currentKey = keyMapper[key] || key
    result[currentKey] = _.isObject(value) ? mapNewKey(value, keysMap) : value
  })
}
*/

// Set current selected library as default library
const state = {
  main: null,
  isLoading: false,
  isCategoriesLoading: false,
  isEventCategoriesLoading: false,
  error: null,
  meta: {},
  categories: null,
  categoriesError: null,
  subcategories: null,
  allCategories: null,
  eventCategories: null,
  books: null,
  currentBook: null,
  isBooksLoading: false,
  booksMeta: {},
  enotes: null,
  isEnotesLoading: false,
  enotesMeta: {},
  searchMain: null,
  search: null,
  isSearchLoading: false,
  searchError: null,
  searchMeta: {},
  isAnnouncementLoading: false,
  announcements: null,
  announcementMeta: {},
  isBookReviewLoading: false,
  bookReviews: null,
  bookReviewMeta: {},
  globalDeliveryList: { G: false, P: false },
  deliveryFee: '',
  shippingFee: '',
  popup: null
}

const getters = {
  getLoading: (state) => state.isLoading,
  getMain: (state) => state.main,
  getMainMetadata: (state) => state.meta,
  isMainLoading: (state) => state.isLoading,
  isMainCategoriesLoading: (state) => state.isCategoriesLoading,
  isMainEventCategoriesLoading: (state) => state.isEventCategoriesLoading,
  getMainCategories: (state) => state.categories,
  getMainSubcategories: (state) => state.subcategories,
  getMainAllCategories: (state) => state.allCategories,
  getMainEventCategories: (state) => state.eventCategories,
  getStoreBooks: (state) => state.books,
  getStoreCurrentBook: (state) => state.currentBook,
  isStoreBooksLoading: (state) => state.isBooksLoading,
  getStoreBooksTotalCount: (state) =>
    state.booksMeta.totalCount || (state.books ? state.books.length : 0),
  isStoreEnotesLoading: (state) => state.isEnotesLoading,
  getStoreEnotes: (state) => state.enotes,
  getStoreEnotesTotalCount: (state) =>
    state.enotesMeta.totalCount || (state.enotes ? state.enotes.length : 0),
  getStoreSearchMain: (state) => state.searchMain,
  isStoreSearchLoading: (state) => state.isSearchLoading,
  getStoreSearch: (state) => state.search,
  getStoreSeachTotalCount: (state) =>
    state.searchMeta.totalCount || (state.search ? state.search.length : 0),
  isStoreAnnouncementLoading: (state) => state.isAnnouncementLoading,
  getStoreAnnouncements: (state) => state.announcements,
  getStoreAnnouncementTotalCount: (state) =>
    state.announcementMeta.totalCount ||
    (state.announcements ? state.announcements.length : 0),
  isStoreBookReviewLoading: (state) => state.isBookReviewLoading,
  getStoreBookReviews: (state) => state.bookReviews,
  getStoreBookReviewAllTotalCount: (state) =>
    state.bookReviewMeta.allTotalCount || 0,
  getStoreBookReviewPurchasedTotalCount: (state) =>
    state.bookReviewMeta.purchasedTotalCount || 0,
  getGlobalDeliveryList: (state) => state.globalDeliveryList,
  getDeliveryFee: (state) => state.deliveryFee,
  getDefaultShipping: (state) => state.shippingFee,
  getPopup: (state) => state.popup
}

const actions = {
  fetchDeliveryFee: ({ commit }, payload) => {
    const {
      emsTp,
      emsAreaCd,
      emsCountryCd,
      bookWeight,
      bookSize,
      units
    } = payload
    return new Promise((resolve, reject) => {
      axios
        .post('/ext/ems/expectation/fee', {
          ems: {
            emsTp,
            emsAreaCd,
            emsCountryCd,
            bookWeight,
            bookSize,
            units
          }
        })
        .then((res) => {
          resolve(res)
          commit('setDeliveryFee', res.data.result)
        })
        .catch((err) => reject(err))
    })
  },
  [DELIVERY_LIST_GET]: ({ commit }, payload) => {
    if (state.globalDeliveryList[payload] != false) {
      return
    }
    commit(STORE_REQUEST)
    return new Promise((resolve, reject) => {
      axios
        .get(`/ext/ems/countries/${payload}`)
        .then((res) => {
          commit(DELIVERY_LIST_SUCCESS, {
            data: res.data.result.countries,
            tp: payload
          })
          resolve(res)
        })
        .catch((err) => {
          commit(DELIVERY_LIST_FAILED, err)
          reject(err)
        })
    })
  },

  [STORE_MAIN_GET]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(STORE_REQUEST)
      const formatted = {}

      axios
        .get(`/store/main/`)
        .then((resp) => {
          // First format data with keyMapper const
          Object.keys(resp.data.result).map((key) => {
            resp.data.result[key].map((item) => {
              Object.keys(item).map((k2) => {
                if (keyMapper[k2]) {
                  item[keyMapper[k2]] = item[k2]
                }
              })
            })
            if (keyMapper[key]) {
              formatted[keyMapper[key]] = resp.data.result[key]
            } else {
              formatted[key] = resp.data.result[key]
            }
          })
          commit(STORE_SUCCESS, {
            main: formatted,
            meta: { lastLoaded: resp.data.respTime }
          })
          resolve(resp)
        })
        .catch((err) => {
          commit(STORE_FAILURE, err)
          reject(err)
        })
    })
  },
  [STORE_CATEGORIES_GET_ALL]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(STORE_CATEGORIES_REQUEST)

      axios
        .get('/book/category/list-all')
        .then((resp) => {
          commit(STORE_CATEGORIES_SUCCESS, { all: resp.data.result.catgryList })
          resolve(resp)
        })
        .catch((err) => {
          commit(STORE_CATEGORIES_FAILURE, err)
          reject(err)
        })
    })
  },
  [STORE_CATEGORIES_GET_LIST]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(STORE_CATEGORIES_REQUEST)
      axios
        .get(`/book/category/list`)
        .then((resp) => {
          resp.data.result.catgryList.map((item) => {
            Object.keys(item).map((k2) => {
              if (keyMapper[k2]) {
                item[keyMapper[k2]] = item[k2]
              }
            })
          })
          commit(STORE_CATEGORIES_SUCCESS, {
            categories: resp.data.result.catgryList
          })
          resolve(resp)
        })
        .catch((err) => {
          commit(STORE_CATEGORIES_FAILURE, err)
          reject(err)
        })
    })
  },
  [STORE_CATEGORIES_GET]: ({ commit }, id) => {
    return new Promise((resolve, reject) => {
      commit(STORE_CATEGORIES_REQUEST)
      axios
        .get(`/book/category/list/${id}/`)
        .then((resp) => {
          resp.data.result.catgryList.map((item) => {
            Object.keys(item).map((k2) => {
              if (keyMapper[k2]) {
                item[keyMapper[k2]] = item[k2]
              }
            })
          })
          commit(STORE_CATEGORIES_SUCCESS, {
            subcategories: resp.data.result.catgryList
          })
          resolve(resp)
        })
        .catch((err) => {
          commit(STORE_CATEGORIES_FAILURE, err)
          reject(err)
        })
    })
  },
  getThisSubCategoryList: ({ commit }, id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/book/category/list/${id}/`)
        .then((resp) => {
          resp.data.result.catgryList.map((item) => {
            Object.keys(item).map((k2) => {
              if (keyMapper[k2]) {
                item[keyMapper[k2]] = item[k2]
              }
            })
          })
          resolve(resp)
        })
        .catch((err) => {
          commit(STORE_CATEGORIES_FAILURE, err)
          reject(err)
        })
    })
  },
  [STORE_BOOK_GET_LIST]: ({ commit }, { category = 'RC', page = 1 }) => {
    return new Promise((resolve, reject) => {
      commit(STORE_BOOK_REQUEST)
      /*
        - 검색 기준 카테고리 : 
            연관도서 (RL), 추천도서 (RC), 신간 (NW), 인기 (PL)
        - 정렬 카테고리 기준 값 : 
            판매량 (SA), 출간일 (PD), 최저가 (MX), 최고가 (MN) : 값이 없는 경우=SA
      */
      axios
        .get(`/book/${category}/list?pageRow=15&pageNo=${page}`)
        .then((resp) => {
          commit(STORE_BOOK_SUCCESS, {
            books: resp.data.result.bookList,
            meta: {
              lastLoaded: resp.data.respTime,
              totalCount: resp.data.page.totalCount
            }
          })
          resolve(resp)
        })
        .catch((err) => {
          commit(STORE_BOOK_FAILURE, err)
          reject(err)
        })
    })
  },
  [STORE_BOOK_GET]: ({ commit }, id) => {
    return new Promise((resolve, reject) => {
      commit(STORE_BOOK_REQUEST)

      axios
        .get(`/book/info/${id}`)
        .then((resp) => {
          commit(STORE_BOOK_SUCCESS, {
            book: resp.data.result.bookInfo,
            shipping: resp.data.result.shippingFee
          })
          resolve(resp)
        })
        .catch((err) => {
          commit(STORE_BOOK_FAILURE, err)
          reject(err)
        })
    })
  },
  [STORE_BOOK_REVIEW_GET_LIST]: (
    { commit, state },
    { id, search, page, pageRow, category }
  ) => {
    return new Promise((resolve, reject) => {
      commit(STORE_BOOK_REVIEW_REQUEST)

      id = id || state.currentBook.bookCd

      axios
        .get(
          `/book/review/${id}/list?pageNo=${page}&pageRow=${pageRow}${
            search ? `&searchTp=${search}` : ''
          }${category ? `&catgryTp=${category}` : ''}`
        )
        .then((resp) => {
          commit(STORE_BOOK_REVIEW_SUCCESS, {
            reviews: resp.data.result.bookReviewList,
            meta: {
              allTotalCount: resp.data.result.listAllCnt,
              purchasedTotalCount: resp.data.result.listPurchaseCnt
            }
          })
          resolve(resp)
        })
        .catch((err) => {
          commit(STORE_BOOK_REVIEW_FAILURE, err)
          reject(err)
        })
    })
  },
  [STORE_CATEGORY_BOOKS_GET_LIST]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      commit(STORE_CATEGORY_BOOKS_REQUEST)
      // api 문서보고 수정 sortingOrder > searchTp
      axios
        .get(
          `/book/category/curriculum/list?pageRow=15&searchTp=${
            payload.sort || 'SA'
          }&pageNo=${payload.page || 1}${
            payload.category === 'A'
              ? ''
              : `&catgryCd=${
                  payload.subcategory
                    ? `${payload.subcategory}`
                    : `${payload.category}`
                }`
          }`
        )
        .then((resp) => {
          commit(STORE_CATEGORY_BOOKS_SUCCESS, {
            books: resp.data.result.bookList,
            meta: {
              lastLoaded: resp.data.respTime,
              totalCount: resp.data.page.totalCount
            }
          })
          resolve(resp)
        })
        .catch((err) => {
          commit(STORE_CATEGORY_BOOKS_FAILURE, err)
          reject(err)
        })
    })
  },
  [STORE_ENOTE_GET_LIST]: ({ commit }, { sort = 'PL', page = 1 }) => {
    return new Promise((resolve, reject) => {
      commit(STORE_ENOTE_REQUEST)

      axios
        .get(`/store/enote/list?pageNo=${page}&searchTp=${sort}`)
        .then((resp) => {
          commit(STORE_ENOTE_SUCCESS, {
            enotes: resp.data.result.enoteList,
            meta: {
              lastLoaded: resp.data.respTime,
              totalCount: resp.data.page.totalCount
            }
          })
          resolve(resp)
        })
        .catch((err) => {
          commit(STORE_ENOTE_FAILURE, err)
          reject(err)
        })
    })
  },
  [STORE_SEARCH_MAIN]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(STORE_SEARCH_REQUEST)

      axios
        .get(`/store/search/main/`)
        .then((resp) => {
          commit(STORE_SEARCH_SUCCESS, { main: resp.data.result })
          resolve(resp)
        })
        .catch((err) => {
          commit(STORE_SEARCH_FAILURE, err)
          reject(err)
        })
    })
  },
  [STORE_SEARCH_TERM]: ({ commit }, search) => {
    return new Promise((resolve, reject) => {
      commit(STORE_SEARCH_REQUEST)

      axios
        .post(`book/search`, search)
        .then((resp) => {
          commit(STORE_SEARCH_SUCCESS, {
            search: resp.data.result?.bookList || ['noData'],
            meta: resp.data.page
          })
          resolve(resp)
        })
        .catch((err) => {
          commit(STORE_SEARCH_FAILURE, err)
          reject(err)
        })
    })
  },
  [STORE_ANNOUNCEMENT_GET_LIST]: ({ commit }, { page, pageRow }) => {
    return new Promise((resolve, reject) => {
      commit(STORE_ANNOUNCEMENT_REQUEST)

      page = page || 1
      pageRow = pageRow || 10

      axios
        .get(`/customer/notice/list?pageNo=${page}&pageRow=${pageRow}`)
        .then((resp) => {
          commit(STORE_ANNOUNCEMENT_SUCCESS, {
            announcements: resp.data.result.noticeList,
            meta: {
              totalCount: resp.data.page.totalCount
            }
          })

          resolve(resp)
        })
        .catch((err) => {
          commit(STORE_ANNOUNCEMENT_FAILURE, err)
          reject(err)
        })
    })
  },
  [STORE_POPUP]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(STORE_REQUEST)
      axios
        .get('/store/popup/')
        .then((resp) => {
          commit(STORE_POPUP_SUCCESS, {
            popup: resp.data.result.popup
            // resp
          })
          resolve(resp)
        })
        .catch((err) => {
          commit(STORE_POPUP_FAILURE, err)
          reject(err)
        })
    })
  },
  [STORE_EVENT_CATEGORIES_GET]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(STORE_EVENT_CATEGORIES_REQUEST)
      axios
        .get('/book/category/event')
        .then((resp) => {
          commit(STORE_EVENT_CATEGORIES_SUCCESS, {
            count: resp.data.result.count,
            categories: resp.data.result.categories
          })
          resolve(resp)
        })
        .catch((err) => {
          commit(STORE_EVENT_CATEGORIES_FAILURE, err)
          reject(err)
        })
    })
  }
}

const mutations = {
  setDeliveryFee: (state, payload) => {
    state.deliveryFee = payload
  },
  [DELIVERY_LIST_SUCCESS]: (state, { data, tp }) => {
    if (tp === 'G') {
      state.globalDeliveryList['G'] = data[0].emsAreaList
    }
    if (tp === 'P') {
      state.globalDeliveryList['P'] = data
    }

    state.isLoading = false
  },
  [DELIVERY_LIST_FAILED]: (state) => {
    state.isLoading = false
  },
  [STORE_REQUEST]: (state) => {
    if (state.isLoading) return
    state.isLoading = true
  },
  [STORE_LOADING_STOP]: (state) => {
    if (!state.isLoading) return
    state.isLoading = false
  },
  [STORE_SUCCESS]: (state, { main, meta }) => {
    if (main) {
      state.main = main
    }
    if (meta) {
      state.meta = meta
    }
    state.isLoading = false
  },
  [STORE_FAILURE]: (state, err) => {
    if (err) state.error = err
    state.isLoading = false
  },
  [STORE_CATEGORIES_REQUEST]: (state) => {
    state.isCategoriesLoading = true
  },
  [STORE_CATEGORIES_SUCCESS]: (state, { categories, subcategories, all }) => {
    state.isCategoriesLoading = false
    if (categories) state.categories = categories

    if (subcategories) {
      subcategories.map((sc) => {
        Object.keys(sc).map((key) => {
          if (keyMapper[key]) {
            sc[keyMapper[key]] = sc[key]
          }
        })
      })
      state.subcategories = subcategories
    }

    if (all) {
      state.allCategories = all
    }
  },
  [STORE_CATEGORIES_FAILURE]: (state, err) => {
    state.isCategoriesLoading = false
    if (err) state.categoriesError = err
  },
  [STORE_BOOK_REQUEST]: (state) => {
    state.isBooksLoading = true
  },
  [STORE_BOOK_SUCCESS]: (state, { books, book, meta, shipping }) => {
    state.isBooksLoading = false
    state.shippingFee = shipping
    if (!books && !book && meta) {
      // 웹에서 리스트 아무것도없을때
      if (meta.totalCount == 0) {
        state.books = []
      }
    }

    if (books) {
      if (meta.totalCount == 0) {
        state.books = []
      }
      //리스트 가져오는 분기점

      books.map((book) => {
        Object.keys(book).map((key) => {
          if (keyMapper[key]) {
            book[keyMapper[key]] = book[key]
          }
        })
      })
      state.books = books
    }

    if (book) {
      //책상세 가져오는 분기점
      const newBook = mapNewKey(book, keyMapper)
      newBook.hasPaper = book.buyTp.paperbook
      newBook.hasEbook = book.buyTp.ebook
      newBook.hasPod = book.buyTp.pod

      newBook.purchaseOptions = []

      if (
        book.bookPrice.paperbook.listPrice ||
        book.bookPrice.paperbook.salePrice
      ) {
        newBook.purchaseOptions.push({
          type: 'paper',
          name: '종이책',
          listPrice: book.bookPrice.paperbook.listPrice,
          rate: book.bookPrice.paperbook.rate,
          price: book.bookPrice.paperbook.salePrice,
          currencies: book.bookPrice.paperbook?.currencies || [],
          quantity: 1
        })
      }

      if (book.bookPrice.ebook.listPrice || book.bookPrice.ebook.salePrice) {
        newBook.purchaseOptions.push({
          type: 'ebook',
          name: 'eBook',
          listPrice: book.bookPrice.ebook.listPrice,
          rate: book.bookPrice.ebook.rate,
          price: book.bookPrice.ebook.salePrice,
          currencies: book.bookPrice.ebook?.currencies || [],
          quantity: 1
        })
      }
      if (book.bookPrice.pod?.options.length > 0) {
        book.bookPrice.pod?.options.map((pod) => {
          newBook.purchaseOptions.push({
            type: pod.optId,
            name: pod.optDesc,
            price: pod.optPrice,
            quantity: 1,
            ...pod
          })
        })
      }

      /* 
        If paper book list price === 0, set main price as ebook's list price
      */
      newBook.price = book.bookPrice.paperbook.listPrice
        ? book.bookPrice.paperbook.listPrice
        : book.bookPrice.ebook.listPrice
      newBook.salePrice = book.bookPrice.paperbook.salePrice
        ? book.bookPrice.paperbook.salePrice
        : book.bookPrice.ebook.salePrice
      newBook.rate = book.bookPrice.paperbook.listPrice
        ? book.bookPrice.paperbook.rate
        : book.bookPrice.ebook.rate

      state.currentBook = newBook
    }

    if (meta) {
      state.booksMeta = { ...state.booksMeta, ...meta }
    }
  },
  [STORE_BOOK_FAILURE]: (state, err) => {
    state.isBooksLoading = false
    state.error = err
  },
  [STORE_CATEGORY_BOOKS_REQUEST]: (state) => {
    state.isBooksLoading = true
  },
  [STORE_CATEGORY_BOOKS_SUCCESS]: (state, { books, meta }) => {
    state.isBooksLoading = false

    if (books) {
      books.map((book) => {
        Object.keys(book).map((key) => {
          if (keyMapper[key]) {
            book[keyMapper[key]] = book[key]
          }
        })
      })
      state.books = books
    }

    if (meta) {
      state.booksMeta = { ...state.booksMeta, ...meta }
    }
  },
  [STORE_CATEGORY_BOOKS_FAILURE]: (state, err) => {
    state.isBooksLoading = false
    state.error = err
  },
  [STORE_ENOTE_REQUEST]: (state) => {
    state.isEnotesLoading = true
  },
  [STORE_ENOTE_SUCCESS]: (state, { enotes }) => {
    state.isEnotesLoading = false
    if (enotes) {
      enotes.map((enote) => {
        Object.keys(enote).map((key) => {
          if (keyMapper[key]) {
            enote[keyMapper[key]] = enote[key]
          }
        })
      })
      state.enotes = enotes
    }
  },
  [STORE_ENOTE_FAILURE]: (state, err) => {
    state.isEnotesLoading = false
    state.error = err
  },
  [STORE_SEARCH_REQUEST]: (state) => {
    state.isSearchLoading = true
  },
  [STORE_SEARCH_SUCCESS]: (state, { main, search, meta }) => {
    state.isSearchLoading = false
    if (main) {
      main.newBooks = main.newBooks.map((book) => {
        return mapNewKey(book, keyMapper)
      })
      main.popularBooks = main.popularBooks.map((book) => {
        return mapNewKey(book, keyMapper)
      })
      state.searchMain = main
    }

    if (search) {
      search == 'noData'
        ? (search = [])
        : (search = search.map((book) => {
            return mapNewKey(book, keyMapper)
          }))
      state.search = search
    }

    if (meta) {
      state.searchMeta = meta
    }
  },
  [STORE_SEARCH_FAILURE]: (state, err) => {
    state.isSearchLoading = false

    state.searchError = err
  },
  [STORE_ANNOUNCEMENT_REQUEST]: (state) => {
    state.isAnnouncementLoading = true
  },
  [STORE_ANNOUNCEMENT_SUCCESS]: (state, { announcements, meta }) => {
    state.isAnnouncementLoading = false

    if (announcements) {
      state.announcements = announcements
    }
    if (meta) {
      state.announcementMeta = meta
    }
  },
  [STORE_ANNOUNCEMENT_FAILURE]: (state, err) => {
    state.isAnnouncementLoading = false
    state.error = err
  },
  [STORE_BOOK_REVIEW_REQUEST]: (state) => {
    state.isBookReviewLoading = true
  },
  [STORE_BOOK_REVIEW_SUCCESS]: (state, { reviews, meta }) => {
    state.isBookReviewLoading = false

    if (reviews) {
      state.bookReviews = reviews
    }

    if (meta) {
      state.bookReviewMeta = meta
    }
  },
  [STORE_BOOK_REVIEW_FAILURE]: (state, err) => {
    state.isBookReviewLoading = false
    state.error = err
  },
  [STORE_POPUP_SUCCESS]: (state, popup) => {
    state.popup = popup
    state.isLoading = false
  },
  [STORE_POPUP_FAILURE]: (state, err) => {
    state.error = err
    state.isLoading = false
  },
  [STORE_EVENT_CATEGORIES_REQUEST]: (state) => {
    state.isEventCategoriesLoading = true
  },
  [STORE_EVENT_CATEGORIES_SUCCESS]: (state, data) => {
    state.eventCategories = data
    state.isEventCategoriesLoading = false
  },
  [STORE_EVENT_CATEGORIES_FAILURE]: (state, err) => {
    state.error = err
    state.isEventCategoriesLoading = false
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
